
<div class="fixed-top bg-warning text-dark shadow fadeIn" *ngIf="isUpdateAvailable" style="z-index: 9999;">
  <div class="container-fluid">
    <div class="row py-2 px-3 align-items-center">
      <div class="col-12 col-md d-flex align-items-center gap-2 mb-2 mb-md-0"><i class="lnr lnr-warning" aria-hidden="true"></i><span class="small">{{ 'UPDATES.OUT_OF_DATE' | translate }}</span></div>
      <div class="col-12 col-md-auto d-flex justify-content-center justify-content-md-end">
        <button class="btn btn-dark btn-sm fw-bold" type="button" (click)="refresh()"><i class="lnr lnr-refresh2 me-2" aria-hidden="true"></i><span>{{ 'UPDATES.REFRESH' | translate }}</span></button>
      </div>
    </div>
  </div>
</div>